import { Environment, EnvironmentConfig } from 'shared/models/feature-flag';

const compareVersions = (current: string, required: string): boolean => {
  const currentParts = current.split('.').map(Number);
  const requiredParts = required.split('.').map(Number);

  for (let i = 0; i < Math.max(currentParts.length, requiredParts.length); i++) {
    const currentPart = currentParts[i] || 0;
    const requiredPart = requiredParts[i] || 0;

    if (currentPart > requiredPart) return true;
    if (currentPart < requiredPart) return false;
  }

  return true;
};

export const isFeatureEnabledInEnvironment = (config: EnvironmentConfig, currentEnv: Environment, currentVersion: string): boolean => {
  if (config.environment !== currentEnv) {
    return false;
  }

  return compareVersions(currentVersion, config.fromVersion);
};
